import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-dialog-info-capacita-spesa-valore',
  templateUrl: './dialog-info-capacita-spesa-valore.component.html',
  styleUrls: ['./dialog-info-capacita-spesa-valore.component.css']
})
export class DialogInfoCapacitaSpesaValore {

  constructor(public dialogRef: MatDialogRef<DialogInfoCapacitaSpesaValore>) { }

}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/dialogs/dialog-info-capacita-spesa-valore/dialog-info-capacita-spesa-valore.component.ts